<template>
  <div class="coze-core">
    <div class="message-box">
      <div class="message-box__info">
        <div class="bot-info">
          <img class="bot-info__avatar" :src="botAvatar" />
          <span class="bot-info__name">{{
            props.config?.practiceContent?.customerName || '张经理'
          }}</span>
        </div>
      </div>
      <!-- 消息对话 -->
      <div class="message-list__box">
        <ul class="message-list">
          <li
            v-for="(message, index) in messageListCompt"
            :key="`${message.eventName}-${index}`"
            class="message-list__item"
          >
            <ChatCard :bot-info="props.botInfo" :message="message"></ChatCard>
          </li>
          <div class="message-list__cover"></div>
        </ul>
      </div>

      <div class="message-status">
        <template v-if="endedReason">
          <div class="message-status__end-reason">
            {{ endedReason }}
          </div>
          <div class="message-status__duration message-status__duration--ended">
            {{ callDurationInfo.durationStr }}
          </div>
        </template>
        <template v-else-if="callDurationInfo.duration">
          <!-- 声纹展示暂时注释
          <div class="message-status__voice-bar">
            <VolumeLine :volume="5"></VolumeLine>
          </div>
          -->
          <div class="message-status__duration">
            {{ callDurationInfo.durationStr }}
          </div>
        </template>
        <template v-else>
          <div class="message-status__calling">连接中...</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import h5Api from '@/utils/h5/h5-others'
// import { RealtimeUtils, RealtimeClient, EventNames } from '@coze/realtime-api'
import { RealtimeClient, EventNames } from '@coze/realtime-api'
import {
  onMounted,
  ref,
  watch,
  defineProps,
  computed,
  onUnmounted,
  defineExpose,
  defineEmits,
  defineOptions
} from 'vue'
import xbb from '@xbb/xbb-utils'
import ChatCard from './chat-card/index.vue'
// import VolumeLine from '../volume-line.vue'
import { parseAliPracticeEndContent } from '../../ali-end-protocol'

defineOptions({
  name: 'CozeCore'
})

// emit
const emit = defineEmits(['on-start', 'on-end'])

// props
const props = defineProps({
  config: {
    type: Object,
    required: true,
    default: () => ({})
  }
})

const botAvatar = require('@/assets/ai-avatar/ai-practice-partner-man.png')

const timeInfo = ref({
  startTime: 0,
  endTime: 0
})
// 声纹音量逻辑暂时注释
// const currVolume = ref(0)
const durationInterval = ref(null)
// 声纹定时器暂时注释
// const voiceInterval = ref(null)
const client = ref(null)
const isCLientConnecting = ref(false) // 连接-中
const isClientConnected = ref(false) // 链接-成功
const messageList = ref([])
const isUserSpeechStarted = ref(false)
const currentUserMessageIndex = ref(-1) // 当前用户消息在列表中的索引
const currentBotMessageIndex = ref(-1) // 当前机器人消息在列表中的索引
const botMessageContent = ref('') // 累积机器人回复内容
const endedReason = ref('')

const callDurationInfo = computed(() => {
  if (endedReason.value) {
    return {
      duration: 0,
      durationStr: '对方已挂断'
    }
  }

  const duration = timeInfo.value.endTime - timeInfo.value.startTime
  const seconds = Math.floor(duration / 1000)

  // 计算分钟和秒
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return {
    duration: seconds,
    durationStr: `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }
})

const messageListCompt = computed(() => {
  return messageList.value.map((message) => {
    return {
      ...message,
      styles: {
        isUser: message.sender === 'user',
        isBot: message.sender === 'bot',
        isTranscribing: message.data?.isTranscribing || false,
        isStreaming: message.data?.isStreaming || false
      }
    }
  })
})

const endCallByReason = (endReason = '') => {
  if (endedReason.value) {
    return
  }

  endedReason.value = endReason
  stopClient({ preserveEndReason: true })
  emit('on-end', endReason)
}

const updateBotMessageContent = (message, rawContent, isStreaming = false) => {
  const { displayContent, endReason, hasEndMarker } = parseAliPracticeEndContent(rawContent)
  const nextMessage = {
    ...message,
    sender: 'bot',
    timestamp: Date.now(),
    data: {
      ...message.data,
      isStreaming,
      rawContent,
      data: {
        ...message.data.data,
        content: displayContent
      }
    }
  }

  if (currentBotMessageIndex.value === -1) {
    messageList.value.push(nextMessage)
    currentBotMessageIndex.value = messageList.value.length - 1
  } else {
    messageList.value[currentBotMessageIndex.value] = {
      ...messageList.value[currentBotMessageIndex.value],
      ...nextMessage
    }
  }

  if (hasEndMarker) {
    endCallByReason(endReason)
  }
}

const initBefore = async () => {
  // 1.检查设备权限
  if (window.plus) {
    h5Api.h5ChoosePermission({ type: 4, onSuccess: init })
  } else {
    init()
  }
  // const result = await RealtimeUtils.checkDevicePermission()
  // if (!result.audio) {
  //   // throw new Error('需要麦克风访问权限')
  //   if (window.plus) {
  //     h5Api.h5ChoosePermission({ type: 4, onSuccess: init })
  //   } else {
  //     init()
  //   }
  // } else {
  //   init()
  // }
}

const init = async () => {
  client.value = await initClient()
  startClient()
}

const initClient = async () => {
  console.log('props.config', props.config)
  // 1.检查设备权限
  // const checkVideo = false // 如需申请摄像头权限，请设置为 true
  // const result = await RealtimeUtils.checkDevicePermission()

  // 检查麦克风权限
  // if (!result.audio) {
  //   throw new Error('需要麦克风访问权限')
  // }
  //   // 如果申请摄像头权限，还需检查摄像头权限
  //   if (checkVideo && !result.video) {
  //     throw new Error('需要摄像头访问权限')
  //   }

  // 2. 初始化客户端
  const clientInstance = new RealtimeClient({
    accessToken: props.config.accessToken, // 替换为准备工作中获取的访问密钥
    botId: props.config.botId, // 替换为智能体 ID
    connectorId: '1024', // 渠道 ID，固定为 1024
    conversationId: props.config.conversationId,
    debug: xbb.isDevEnv() // 可选：是否开启调试模式，默认为 false
    // allowPersonalAccessTokenInBrowser: true // 可选：允许在浏览器中使用个人访问令牌
  })

  // 3.监听所有事件
  clientInstance.on(EventNames.ALL, (eventName, data) => {
    // console.log('🚀 ~ init ~ eventName:', eventName, data)
    handleEvent(eventName, data)
  })

  return clientInstance
}

// 初始化智能体
const initBotConfig = () => {
  // 这里可以根据需要初始化一些配置项，例如重置消息列表、状态等
  console.log('初始化客户端配置', client.value)
  client.value.sendMessage({
    id: xbb.guid(),
    event_type: 'session.update',
    data: {
      voice_id: '7426720361733177353', // 语音
      chat_config: {
        custom_variables: {
          ...(props.config?.promptVariable || {})
        }
      },
      stream_mode: 'output_no_stream',
      enable_gender: true,
      gender: 'male',
      enable_nostream: true, // 是否开启二次识别模式：
      silence_threshold_ms: 500, // 当用户暂停说话时，持续静音多久后，触发语义判停检测。单位为 ms。默认为 300ms。
      silence_duration_ms: 500, // server_vad 模式下，检测语音停止的静音持续时间，单位为 ms。取值范围为 200~2000，默认为 500ms。
      speech_rate: 45 // 语速
    }
  })
}

// 事件处理函数 - 根据 Coze 实时 API 下行事件文档梳理
const handleEvent = (eventName, data) => {
  const message = {
    eventName,
    data,
    sender: 'bot', // bot 机器人，user 用户
    timestamp: Date.now()
  }
  console.log('🚀 ~ handleEvent ~ message:', eventName, message)
  // 使用 if-else 结构处理所有下行事件
  if (eventName === EventNames.CONNECTING) {
    console.log('🔄 正在连接...')
    // 可以在这里更新UI连接状态
    isCLientConnecting.value = true
  } else if (eventName === EventNames.CONNECTED) {
    console.log('🔗 连接成功')
    // 可以在这里更新UI连接状态
    isCLientConnecting.value = false
    isClientConnected.value = true
    onCallDuration()
    emit('on-start')
  } else if (eventName === EventNames.DISCONNECTED) {
    console.log('🔌 连接断开')
    // 可以在这里更新UI断开状态
    isClientConnected.value = false
  }
  // else if (eventName === EventNames.ERROR) {
  //   console.error('❌ 连接错误:', data)
  //   // 可以在这里显示错误提示
  // } else if (eventName === EventNames.CONVERSATION_CHAT_CREATED) {
  //   console.log('🆕 对话创建:', data)
  //   // 新对话开始，可以重置UI状态，清除之前的消息等
  // } else if (eventName === EventNames.CONVERSATION_CHAT_COMPLETED) {
  //   console.log('✅ 对话完成:', data)
  //   // 对话结束，可以显示完成状态
  // } else if (eventName === EventNames.CONVERSATION_CHAT_FAILED) {
  //   console.error('💥 对话失败:', data)
  //   // 对话失败，需要错误处理和用户提示
  // }
  else if (eventName === EventNames.CONVERSATION_MESSAGE_DELTA) {
    // 流式消息增量，用于实时显示机器人回复
    if (
      message.data.data.role === 'assistant' &&
      message.data.data.type === 'answer' &&
      isUserSpeechStarted.value === false &&
      data.data.content
    ) {
      console.log('📝 机器人-消息增量:', data)
      if (currentBotMessageIndex.value === -1) {
        botMessageContent.value = data.data.content || ''
      } else {
        botMessageContent.value += data.data.content || ''
      }
      updateBotMessageContent(message, botMessageContent.value, true)
    }
  } else if (eventName === EventNames.CONVERSATION_MESSAGE_COMPLETED) {
    console.log('💬 消息完成:', data)
    // 消息完成，包含完整内容
    if (message.data.data.role === 'user' && message.data.data.type === 'question') {
      console.log('👤 消息完成-用户消息:', message.data.data.content)
      // 检查是否有临时消息需要替换
      const lastMessage = messageList.value[messageList.value.length - 1]
      if (lastMessage.sender === 'user') {
        // 替换临时消息
        messageList.value[messageList.value.length - 1] = {
          ...message,
          sender: 'user'
        }
      } else {
        // 添加新消息
        messageList.value.push({
          ...message,
          sender: 'user'
        })
      }
      // 更新UI显示用户消息
    } else if (
      message.data.data.role === 'assistant' &&
      message.data.data.type === 'answer' &&
      isUserSpeechStarted.value === false
    ) {
      console.log('🤖 消息完成-机器人回复:', data.data.content)
      const rawContent =
        data.data.content ||
        messageList.value[currentBotMessageIndex.value]?.data?.rawContent ||
        botMessageContent.value

      updateBotMessageContent(message, rawContent, false)
      currentBotMessageIndex.value = -1
      botMessageContent.value = ''
    }
  } else if (eventName === EventNames.CONVERSATION_AUDIO_TRANSCRIPT_DELTA) {
    console.log('🎤 用户-语音转文字增量:', data)
    // 语音转文字的增量结果
    // 更新当前用户消息的内容
    if (currentUserMessageIndex.value >= 0) {
      messageList.value[currentUserMessageIndex.value].data.data.content = data.data.content || ''
      messageList.value[currentUserMessageIndex.value].data.isTranscribing = true
    }
  } else if (eventName === EventNames.AUDIO_USER_SPEECH_STARTED) {
    console.log('🎙️ 用户-开始说话:', data)
    // 用户开始说话
    isUserSpeechStarted.value = true
    // 插入临时的用户消息状态
    const tempMessage = {
      ...message,
      sender: 'user',
      isTemp: true // 标记为临时消息
    }
    // 重置当前机器人消息索引
    if (currentBotMessageIndex.value !== -1) {
      messageList.value[currentBotMessageIndex.value].data.isStreaming = false
      currentBotMessageIndex.value = -1
      botMessageContent.value = ''
    }
    messageList.value.push(tempMessage)
    currentUserMessageIndex.value = messageList.value.length - 1
  } else if (eventName === EventNames.AUDIO_USER_SPEECH_STOPPED) {
    console.log('🔇 用户-停止说话:', data)
    // 标记转录完成
    if (currentUserMessageIndex.value >= 0) {
      messageList.value[currentUserMessageIndex.value].data.isTranscribing = false
      messageList.value[currentUserMessageIndex.value].isTemp = false
    }
    currentUserMessageIndex.value = -1 // 重置索引
    // 用户停止说话
    isUserSpeechStarted.value = false
  }
  //  else if (eventName === EventNames.AUDIO_AGENT_SPEECH_STARTED) {
  //   console.log('🔊 机器人开始说话:', data)
  //   // 机器人开始说话
  // } else if (eventName === EventNames.AUDIO_AGENT_SPEECH_STOPPED) {
  //   console.log('🤐 机器人停止说话:', data)
  //   // 机器人停止说话
  // } else if (eventName === EventNames.SESSION_CREATED) {
  //   console.log('📋 会话创建:', data)
  //   // 用户成功进入房间
  // }
  // else if (eventName === EventNames.CONVERSATION_CREATED) {
  //   console.log('💭 对话创建:', data)
  //   // 会话创建
  //   messageList.value.push({
  //     ...message,
  //     data: {
  //       ...message.data,
  //       data: {
  //         content: message.data.data.prologue
  //       }
  //     }
  //   })
  // }
  // else if (eventName === EventNames.CONVERSATION_CHAT_IN_PROGRESS) {
  //   console.log('⏳ 对话处理中:', data)
  //   // 对话正在处理中
  // } else if (eventName === EventNames.CONVERSATION_CHAT_REQUIRES_ACTION) {
  //   console.log('🔧 对话需要插件:', data)
  //   // 对话需要插件
  // } else if (eventName === EventNames.SERVER_ERROR) {
  //   console.error('🚨 服务端错误:', data)
  //   // 服务端错误
  // }
  else if (eventName === EventNames.BOT_JOIN) {
    console.log('🤖 Bot加入:', data)
    // Bot加入
    initBotConfig()
  }
  // else if (eventName === EventNames.BOT_LEAVE) {
  //   console.log('👋 Bot离开:', data)
  //   // Bot离开
  // } else {
  //   console.log('❓ 未识别的事件:', eventName, data)
  //   // 未知事件，可以记录日志或上报
}

const startClient = async () => {
  if (client.value) {
    // 建立与服务端的连接
    client.value.connect()
    console.log('客户端已连接')
  }
}

const clearTimers = () => {
  clearInterval(durationInterval.value)
  // 声纹定时器暂时注释
  // clearInterval(voiceInterval.value)
  durationInterval.value = null
  // voiceInterval.value = null
  // currVolume.value = 0
}

const stopClient = (options = {}) => {
  const { preserveEndReason = false } = options

  if (client.value) {
    client.value.disconnect()
    client.value = null
    console.log('客户端已停止')
  }

  isCLientConnecting.value = false
  isClientConnected.value = false
  clearTimers()

  if (!preserveEndReason) {
    endedReason.value = ''
  }
}

// 拨号 计时器
const onCallDuration = () => {
  timeInfo.value.startTime = Date.now()
  timeInfo.value.endTime = timeInfo.value.startTime
  durationInterval.value = setInterval(() => {
    timeInfo.value.endTime = Date.now()
  }, 1000)
  // 声纹模拟音量暂时注释
  // voiceInterval.value = setInterval(() => {
  //   currVolume.value = Math.floor(Math.random() * 10)
  // }, 800)
}

// // 判断点是否激活（从中间向两边）
// const isDotActive = (index) => {
//   const center = 15 // 30个点的中心位置
//   const distance = Math.abs(index - center)
//   // 根据音量计算激活半径
//   const activeRadius = index * 0.5
//   return distance <= activeRadius
// }

defineExpose({
  stopClient,
  messageList,
  timeInfo,
  endedReason
})

// lice-cycle
onMounted(async () => {
  watch(
    () => props.config,
    async (val = {}) => {
      if (val.accessToken) {
        initBefore()
        // client.value = await initClient()
        // startClient()
      }
    }
  )
})
onUnmounted(() => {
  clearTimers()
  stopClient()
})
</script>

<style lang="less" scoped>
.coze-core {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .client-operate {
    flex-shrink: 0;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    background-color: #f5f5f5;
    display: flex;
    gap: 10px;
  }

  .message-box {
    flex-grow: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__info {
      margin-top: 16px;
      width: 100%;
      position: relative;
      // flex-grow: 1;
      flex-shrink: 0;
      display: flex;
      flex-direction: column-reverse;

      .bot-info {
        // margin-top: 80px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px 12px 4px 4px;
        background: #ebecee;
        border-radius: 64px;

        &__avatar {
          width: 24px;
          height: 24px;
        }
        &__name {
          line-height: 24px;
          margin-left: 8px;
          color: #323233;
          font-size: 14px;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        // &__desc {
        //   margin-top: 16px;
        //   font-size: 14px;
        //   color: #646566;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   white-space: nowrap;
        //   width: 80%;
        //   padding: 0 12px;
        //   box-sizing: border-box;
        // }
      }
    }

    .message-list__box {
      width: 100%;
      box-sizing: border-box;
      flex-grow: 1;
      min-height: 0;
      flex-shrink: 1;
      // max-height: 40vh;
      // flex-grow: 1;
      // min-height: 0;
      position: relative;
      margin: 24px 0;
      // height: 308px;
      // max-height: 40vh;

      // &::before {
      //   content: '';
      //   z-index: 1;
      //   left: 0;
      //   position: absolute;
      //   width: 100%;
      //   top: -1px;
      //   height: 24px;
      //   background: linear-gradient(
      //     180deg,
      //     rgba(242, 243, 245, 0.5) 0%,
      //     rgba(242, 243, 245, 0) 100%
      //   );
      //   backdrop-filter: blur(0px);
      // }

      .message-list {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0 24px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        // overflow: auto;
        overflow: hidden;

        &__item {
          margin-top: 20px;
        }
      }
    }
  }

  .message-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // &__voice-bar {
    // }
    &__end-reason {
      width: fit-content;
      max-width: calc(100% - 24px);
      box-sizing: border-box;
      margin: 0 12px;
      padding: 4px 12px;
      border-radius: 64px;
      background: #e5e6eb;
      color: #646566;
      font-size: 12px;
      line-height: 16px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    &__duration {
      color: #969799;
      font-size: 13px;
      margin-top: 24px;

      &--ended {
        color: #f54e4e;
        margin-top: 20px;
      }
    }

    &__calling {
      color: #323232;
      font-size: 16px;
      margin-top: 24px;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
